/**
 * AM.One API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AdrDetailDto { 
    id: string;
    type: AdrDetailDto.TypeEnum;
    title: string;
    /**
     * Document status enumeration (values match the ADR frontmatter schema in schemas/adr.schema.json)
     */
    status: AdrDetailDto.StatusEnum;
    author: string;
    /**
     * Latest Git commit author for the document file, when available.
     */
    lastEditedBy?: string | null;
    created: string;
    lastModified?: string | null;
    supersedes?: string | null;
    supersededBy?: string | null;
    relatesTo?: Array<string>;
    unresolvedComments?: Array<string>;
    relativePath: string;
    branchName: string;
    bodyMarkdown: string;
}
export namespace AdrDetailDto {
    export const TypeEnum = {
        Adr: 'adr'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
    export const StatusEnum = {
        Draft: 'Draft',
        Accepted: 'Accepted',
        Deprecated: 'Deprecated',
        Superseded: 'Superseded'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


